import { toast } from 'react-toastify';
import { runInAction } from 'mobx';
import globalCourseStore from '../../../../../../../../stores/global-course-store';
import globalProgramStore from '../../../../../../../../stores/program-store';
import appApi from '../../../../../../../../api/app-api';
import { displayErrorText } from '../../../../../../../../api/errors/api-error-codes';
import dateUtils from '../../../../../../../../utils/date-format';

export const addNewTaskOperation = async (
  taskName: string | undefined,
  taskPoints: number | undefined,
  dueDate: Date | undefined,
  assignmentTypeId: number,
  onHide: () => any,
) => {
  try {
    const courseId = globalCourseStore.currentId;
    const programId = globalProgramStore.getCurrentId();
    if (!programId || !courseId) {
      throw new Error(
        `Couldn't find programId ${programId} or courseId: ${courseId}`,
      );
    }

    console.log('XXX ', taskName);

    if (
      taskName === undefined ||
      taskName.length <= 3 ||
      taskName.length > 79
    ) {
      toast.warn('יש לעדכן את שם המטלה, ניקוד ותאריך אחרון להגשה לפני השמירה');
      return;
    }

    if (isNaN(Number(taskPoints)) || taskPoints! < 0 || taskPoints! > 100) {
      toast.warn('על הניקוד להיות בין 0 ל100');
      return;
    }

    if (!dueDate) {
      toast.warn('יש לבחור תאריך הגשה');
      return;
    }

    if (!taskPoints) {
      toast.warn('יש לבחור את ניקוד המטלה');
      return;
    }

    if (!assignmentTypeId) {
      toast.warn('יש לבחור את סוב המטלה');
      return;
    }
    console.log('xxxxxxxxx YYYYYYYY 1');

    const res = await appApi.addNewTask(
      programId,
      courseId,
      taskName,
      taskPoints!,
      dateUtils.formattedDateWithNoTime(dueDate),
      assignmentTypeId,
    );
    if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
      return;
    }

    globalCourseStore.updateCourseDetails(
      courseId,
      res.data.body.metadata,
      res.data.body.details,
    );

    const course = globalCourseStore.courses.get(courseId);
    /*    if (course && course.details) {
      const newTask = res.data.body;
      runInAction(() => {
        course!.details!.assignments = [
          ...course!.details!.assignments,
          newTask,
        ];
      });

      //course!.details!.assignment-student-details.push(newTask);
    }*/
    toast.success('הוספת המטלה התבצעה בהצלחה');
    onHide();
  } catch (e) {
    console.log(
      `addNewTaskOperation is failed with: taskName: ${taskName}, taskPoints: ${taskPoints}, dueDate: ${dueDate} with the error ${e}`,
    );
    toast.error(`הוספת מטהל חדשה נכשלה`);
  }
};
